import { Flex } from '@bookjane2/bookjane-design-library';

import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useFetchCombinedSummaryInfoDataContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchCombinedSummaryInfo.data.context';
import { SelectedAgenciesPay } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/SelectedAgenciesPay';
import {
  TextButtonWrapper,
  SendToAgenciesBoldText,
  InfoSection,
  SendToAgenciesText,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { useTranslation } from 'hooks/useTranslation';
import { FC, useState } from 'react';
import { formatPlural } from 'utils/formatPlural';
import { getTranslatedResponse } from 'utils/getTranslatedResponse';

export const AgencyRequestsComponent: FC = () => {
  const { t, i18n } = useTranslation();
  const { data } = useShiftModalDataContext();
  const order = data?.order;
  const { values } = useSendToAgenciesFormContext();
  const {
    data: { availableJaneCount, selectedAgencies },
  } = useFetchCombinedSummaryInfoDataContext();

  const [showMore, setShowMore] = useState(false);
  const onClick = () => setShowMore(!showMore);

  return (
    <Flex flexDirection="column" gap="32px">
      <Flex flexDirection="column" gap="8px">
        <Flex alignItems="center">
          <SendToAgenciesBoldText>{`${getTranslatedResponse(
            order?.status.name,
            'status',
            i18n,
            t,
          )} ${t('shift_modal:SHIFT')}`}</SendToAgenciesBoldText>
        </Flex>

        <InfoSection flexDirection="column" alignContent="baseline" gap="14px">
          <div>
            <SendToAgenciesBoldText>{t('shift_modal:SEND_TO')}:&nbsp;</SendToAgenciesBoldText>
            {selectedAgencies.length > 1 ? (
              showMore ? (
                <SendToAgenciesText>
                  {selectedAgencies.join(', ')}&nbsp;
                  <TextButtonWrapper variant="PurpleText" onClick={onClick}>
                    {t('shift_modal:HIDE')}
                  </TextButtonWrapper>
                </SendToAgenciesText>
              ) : (
                <SendToAgenciesText>
                  {`${selectedAgencies[0]}, ${selectedAgencies[1].slice(0, 2)}...`}&nbsp;
                  <TextButtonWrapper variant="PurpleText" onClick={onClick}>
                    {`+${selectedAgencies.length - 1} ${t('shift_modal:MORE')}`}
                  </TextButtonWrapper>
                </SendToAgenciesText>
              )
            ) : (
              <SendToAgenciesText>{selectedAgencies[0]}</SendToAgenciesText>
            )}
          </div>
          <SendToAgenciesText>{`${availableJaneCount} ${t(
            'shift_modal:AVAILABLE_AGENCY_MEMBERS',
          )}`}</SendToAgenciesText>

          <div>
            <SendToAgenciesBoldText>{t('shift_modal:SEND_OUT')}:&nbsp;</SendToAgenciesBoldText>
            {values.specific_time_selection[0] === 'now' ? (
              <SendToAgenciesText>{t('shift_modal:IMMEDIATELY')}</SendToAgenciesText>
            ) : (
              <SendToAgenciesText>
                {`${formatPlural(
                  'hour',
                  Number.parseInt(values.specific_time_selection[0], 10),
                  true,
                )} ${t('shift_modal:BEFORE_SHIFT_STARTS')}`}
              </SendToAgenciesText>
            )}
          </div>
        </InfoSection>

        <Flex flexDirection="column" padding="0px 8px 0px 8px">
          <SendToAgenciesText>
            {t('shift_modal:SHIFT_AVAILABLE_NOTE_START')}&nbsp;
            <SendToAgenciesBoldText>{formatPlural(order?.position?.name)}</SendToAgenciesBoldText>
            &nbsp;
            {order?.biddable
              ? t('shift_modal:SHIFT_AVAILABLE_NOTE_END_BIDDING')
              : t('shift_modal:SHIFT_AVAILABLE_NOTE_END')}
          </SendToAgenciesText>
        </Flex>
      </Flex>
      <SelectedAgenciesPay />
    </Flex>
  );
};
